<template>
  <div class="query">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              fixed
              title="颍川分支"
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--搜索-->
    <van-search v-model="searchQuery" placeholder="请输入名称搜索" />
    <!--列表-->
    <div style="height: 10px;"></div>
     <template v-for="item in filterItems()">
        <van-cell-group>
          <van-cell :title="item.name" :label="'始祖：'+item.first" is-link />
        </van-cell-group>
     </template>

  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'

export default {
    'name': 'Query',
    data() {
        return {
          searchQuery:'',
          list: [
            {id:1,name:'颍川陈氏',first:'寔公',url:''},
            {id:2,name:'001-颍川陈柳溪派',first:'满公',url:''},
            {id:3,name:'002-颍川陈峡江沙坊陈氏族谱',first:'满公',url:''},
            {id:4,name:'003-颍川陈江西萍北(上粟)陈氏联修谱',first:'满公',url:''},
            {id:5,name:'004-颍川陈义乌雾溪陈氏',first:'乾九府君',url:''},
            {id:6,name:'005-颍川陈湘阳派江西沙地攸镇谱',first:'叔平',url:''},
            {id:7,name:'006-颍川陈江西吉安庐陵篁竹头陈氏',first:'叔坚',url:''},
            {id:8,name:'007-颍川陈衡山南岳陈氏',first:'德公',url:''},
            {id:9,name:'008-颍川陈柏山庄修水杨津支系谱',first:'思大',url:''},
          ]
        };
    },
    computed: {

    },
    methods: {
        ...mapActions(['requestReportQuery']),
        onClickLeft() {
            this.$router.push({path: '/home'});
        },
        filterItems() {
          const query = this.searchQuery.toLowerCase()
          if(this.list) {
            return this.list.filter(item =>
              item.name.toLowerCase().includes(query)
            )
          }
        }
    },
    components: {

    },
    mounted() {

    }
};
</script>

<style scoped>
.query >>> .van-nav-bar {
  z-index: 9;
  background-color: #ed3f2c;
  padding-top: 6px;
}
.query >>> .van-nav-bar__text {
  color: #fff;
}
.query >>> .van-nav-bar__title {
  color: #fff;
}
.query >>> .van-nav-bar .van-icon {
  color: #fff;
}
.query >>> .van-button--primary {
  color: #fff;
  background-color: #ed3f2c;
  border: 0.02667rem solid #ed3f2c;
}
</style>
